export default __webpack_public_path__ + "static/media/TK.fe91b92d.svg";